import React from "react";
import { Text, type TextProps as AriaTextProps } from "react-aria-components";

export type TextProps = {
  text: string;
} & AriaTextProps;

export function Text2({ text, ...props }: TextProps) {
  return (
    <Text className="tw:text-xs tw:leading-[1.35] tw:text-text-tertiary" {...props}>
      {text}
    </Text>
  );
}
